import { useDetailsPanelsActions } from "PFApp/booking/components/details_panel";
import { Button } from "PFComponents/button";
import { useTranslation } from "react-i18next";

import { BookingFormMode } from "../../../booking/components/booking_form/booking_form.types";

type ProfilePreviewAvailabilityActionsProps = {
  canAddBooking?: boolean | null;
  profileId?: number;
};

export const ProfilePreviewAvailabilityActions = ({
  canAddBooking,
  profileId
}: ProfilePreviewAvailabilityActionsProps) => {
  const { t } = useTranslation("core");
  const { openBookingFormSidePanel } = useDetailsPanelsActions();

  if (!canAddBooking) {
    return null;
  }

  const handleAddBooking = () => {
    if (profileId) {
      openBookingFormSidePanel({ profileId }, { mode: BookingFormMode.Create });
    }
  };

  return (
    <Button kind="secondary" onClick={handleAddBooking} key="booking">
      {t("profilePreview.addBooking")}
    </Button>
  );
};
